import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeCheck'
})
export class TimeCheckPipe implements PipeTransform {

  transform(value: boolean): boolean {
    if(value){
      const timeNow = new Date()
      const sevenAm = new Date(new Date().setHours(7, 0 ,0));
      const sevenPm = new Date(new Date().setHours(22, 0 ,0));
      return timeNow < sevenAm || timeNow > sevenPm;
    }
  }

}
